import React from "react";
import { useDispatch } from "react-redux";
import { toggleTheme } from "store/reducers/theme";

const ToggleTheme = () => {
  const [checked, setchecked] = React.useState(true);
  const dispatch = useDispatch();
  const handleChange = () => {
    if (checked) {
      dispatch(toggleTheme());
      setchecked(false);
    } else {
      dispatch(toggleTheme());
      setchecked(true);
    }
  };

  return (
    <div>
      <i
        onClick={handleChange}
        className={checked ? "icon-moon " : "icon-sun"}
      />
    </div>
  );
};

export default ToggleTheme;
